module.exports = __webpack_public_path__ + "img/atl-mockup.7703f383.jpg";